module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-25"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "carousel-container"
  }, [_c('div', {
    staticClass: "carousel"
  }, _vm._l((_vm.cursos), function(curso, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentIndex === index),
        expression: "currentIndex === index"
      }],
      key: index,
      staticClass: "carousel-item"
    }, [_c('a', {
      attrs: {
        "href": curso.link,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": curso.img,
        "alt": curso.descricao
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "cursos-descricao"
    }, [_vm._v(_vm._s(curso.descricao))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "carousel-pagination"
  }, _vm._l((_vm.cursos), function(curso, index) {
    return _c('span', {
      key: index,
      class: ['bullet', {
        active: _vm.currentIndex === index
      }],
      on: {
        "click": function($event) {
          return _vm.setSlide(index)
        }
      }
    })
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v("Qualificações Urcamp Online")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a5198b12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/QualificacaoUrcamp.vue
// module id = 572
// module chunks = 2